const translations = {
    'attr.canopyCap': 'canopyCap',
    'attr.corruption': 'corruption',
    'attr.fertility': 'fertility',
    'attr.fishCap': 'fishCap',
    'attr.wildlifeCap': 'wildlifeCap',
};

export default translations;
